const KeyMirror = require("keymirror");

module.exports = KeyMirror({
    DELETE_USER_BEGIN: true,
    DELETE_USER_SUCCESS: true,
    DELETE_USER_FAILURE: true,
    FETCH_USERS_BEGIN: true,
    FETCH_USERS_SUCCESS: true,
    FETCH_USERS_FAILURE: true
});



// WEBPACK FOOTER //
// ./src/action-types/users.js